import { defineMessages } from 'react-intl';

export default defineMessages({
  facebook: {
    id: 'social-button.facebook',
    defaultMessage: 'Facebook',
  },
  twitter: {
    id: 'social-button.twitter',
    defaultMessage: 'Twitter',
  },
  pinterest: {
    id: 'social-button.pinterest',
    defaultMessage: 'Pinterest',
  },
  tumblr: {
    id: 'social-button.tumblr',
    defaultMessage: 'Tumblr',
  },
  link: {
    id: 'social-button.link',
    defaultMessage: 'Link',
  },
  copy: {
    id: 'social-button.copy',
    defaultMessage: 'Copy',
  },
});



// WEBPACK FOOTER //
// ./src/widget/player-widget/components/social-share/social-button/translations.js